import { Change, LineType, Point, Polyline } from '@ritabygglov/core';
import { uuid } from '../helpers/utility';
import { createCreateChange, createDeleteChange } from '../services/Actions';
import { createPolyline } from '../services/Actions/Polyline';
import { Command } from './Command';

export class CreatePolylineCommand implements Command {
  private elementId: string;
  private polyline: Polyline | undefined;

  constructor(
    private firstPoint: Point,
    private lineType: LineType,
    private renderingOrder: number,
    private userId: string
  ) {
    this.elementId = uuid();
  }

  isEphemeral = false;

  execute(): Change[] {
    this.polyline = createPolyline(
      this.firstPoint,
      this.renderingOrder,
      this.elementId,
      this.userId,
      this.lineType
    );

    // Provisional while the user is still placing points.
    return [createCreateChange(this.polyline, true)];
  }

  undo(): Change[] {
    if (!this.polyline) return [];
    const deleteChange = createDeleteChange(this.polyline, this.userId);
    return deleteChange ? [deleteChange] : [];
  }

  getElementId(): string {
    return this.elementId;
  }
}
